import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be09501"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_main" }
const _hoisted_2 = { class: "tobody_main" }
const _hoisted_3 = ["data-mid"]

import { MemberData } from '@/pinia/types/console';
import { useVirtualList } from '@vueuse/core';
import { computed, useSlots } from 'vue';
import { Forbidden } from './ForbiddenWord.vue';

export interface Column {
  title: string;
  align: string;
  dataIndex?: string;
  width?: string;
  ellipsis?: boolean;
  slots?: { customRender: string };
}
interface MemberTable {
  columns: Column[];
  dataSource: MemberData[] | Forbidden[];
  dataKey: string;
  height: number;
  infiniteScroll?: (...args: any[]) => any;
  infiniteScrollDisabled?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MList',
  props: {
    columns: null,
    dataSource: null,
    dataKey: null,
    height: null,
    infiniteScroll: { type: Function },
    infiniteScrollDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  columns: Column[];
  dataSource: MemberData[] | Forbidden[];
  dataKey: string;
  height: number;
  infiniteScroll?: (...args: any[]) => any;
  infiniteScrollDisabled?: boolean;
};

const solts = useSlots();

const data = computed(() => props.dataSource);

const { list, containerProps, wrapperProps } = useVirtualList(data, {
  itemHeight: 43,
});

return (_ctx: any,_cache: any) => {
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column) => {
          return (_openBlock(), _createElementBlock("th", {
            key: column.title,
            class: "header"
          }, [
            _createElementVNode("div", null, _toDisplayString(column.title), 1)
          ]))
        }), 128))
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps(_unref(containerProps), {
      style: { height: `${props.height - 54}px` },
      "infinite-scroll-distance": 300,
      "infinite-scroll-immediate": false
    }), [
      _createElementVNode("div", _normalizeProps(_guardReactiveProps(_unref(wrapperProps))), [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.data[props.dataKey],
                "data-mid": item.index + '',
                class: "tr_body"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: column.title,
                    class: "colstyle"
                  }, [
                    (_unref(solts)[column?.slots?.customRender ?? ''])
                      ? _renderSlot(_ctx.$slots, column?.slots?.customRender, {
                          key: 0,
                          record: item.data,
                          index: item.index
                        })
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(!_unref(solts)[column?.slots?.customRender ?? ''] ? item.data[column?.dataIndex ?? ''] : ''), 1)
                  ]))
                }), 128))
              ], 8, _hoisted_3))
            }), 128))
          ])
        ])
      ], 16)
    ], 16)), [
      [_directive_infinite_scroll, props.infiniteScroll]
    ])
  ]))
}
}

})